import DashboardPage from './pages/DashboardPage';
import SearchPage from './pages/SearchPage';

export const pages = [
    DashboardPage,
    SearchPage,
];
